import MuiStepper, { type StepperProps } from "@mui/material/Stepper";
import MuiStep, { type StepProps } from "@mui/material/Step";
import MuiStepLabel, { type StepLabelProps } from "@mui/material/StepLabel";
import MuiStepButton, { type StepButtonProps } from "@mui/material/StepButton";
import MuiStepConnector, {
  type StepConnectorProps,
} from "@mui/material/StepConnector";
import MuiStepContent, {
  type StepContentProps,
} from "@mui/material/StepContent";
import MuiStepIcon, { type StepIconProps } from "@mui/material/StepIcon";

export type {
  StepperProps,
  StepProps,
  StepLabelProps,
  StepButtonProps,
  StepConnectorProps,
  StepContentProps,
  StepIconProps,
};

export function Stepper(props: StepperProps) {
  return <MuiStepper {...props} />;
}

export function Step(props: StepProps) {
  return <MuiStep {...props} />;
}

export function StepLabel(props: StepLabelProps) {
  return <MuiStepLabel {...props} />;
}

export function StepButton(props: StepButtonProps) {
  return <MuiStepButton {...props} />;
}

export function StepConnector(props: StepConnectorProps) {
  return <MuiStepConnector {...props} />;
}

export function StepContent(props: StepContentProps) {
  return <MuiStepContent {...props} />;
}

export function StepIcon(props: StepIconProps) {
  return <MuiStepIcon {...props} />;
}
